import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
import { createComponent } from '../utils';
export var Field = createComponent({
    name: 'Field',
    style: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    transition: 175ms;\n\n    & + & {\n      margin-top: 1rem;\n    }\n  "], ["\n    position: relative;\n    transition: 175ms;\n\n    & + & {\n      margin-top: 1rem;\n    }\n  "]))),
});
var templateObject_1;
//# sourceMappingURL=Field.js.map